import React, { useContext, useState, useEffect } from 'react'
import SVG from 'react-inlinesvg'
import styles from '../components/date-picker-styles.module.css'
import DateFormatter from '../../shared/helpers/date-format'
import unavailableIcon from '../../../images/unavailable-icon.svg'
import medium from '../../../images/less-busy-icon.svg'
import high from '../../../images/busy-icon.svg'
import alertIcon from '../../../images/exclamation-triangle.svg'
import mobiCaretDown from '../../../images/mobi-caret-down.svg'
import Alerts from '../../calendar/views/day/alerts'
import { attendanceInfo } from '../helpers/calendar'
import PriceTable from '../../tickets/components/price-table'
import DateFormat from '../../shared/helpers/date-format'
import { TicketsAppContext } from '../context/tickets-app-context'
import LoadingIcon from '../../shared/components/loading-icon'

const { fullDay } = DateFormat

const ListViewDisplay = ({
  dateTime,
  unavailableDay,
  onDayClick,
  oneDay,
  clickedElement,
  setClickedElement,
  fromEvent,
  hours,
  planningInfo,
  selectedDate,
  priceTableInfo,
  setPriceTableInfo,
  isMobiDisplayed,
  showModal,
  remainingTicketsLoading
}) => {
  const {
    actions: { nextStep },
    chosenEvent
  } = useContext(TicketsAppContext)

  const [loading, setLoading] = useState(true)

  useEffect(() => {
    setLoading(remainingTicketsLoading)
  }, [remainingTicketsLoading])

  const onSubmit = event => {
    event.preventDefault()
    event.stopPropagation()
    if (!selectedDate) {
      return null
    }
    nextStep()
  }

  const clickedDay = (e, dateTime) => {
    // onDayClick is from calendar.js it sets and styles the selected day
    onDayClick(dateTime, {}, e)

    // setClickedElement is a state from the list views
    // it's used to determine what mobile date is selected
    setClickedElement(dateTime)
  }

  // display the dates as text
  const shortDays = dateTime => {
    let splitDay = DateFormatter.fullDay(dateTime).split(' ')
    splitDay[0] = DateFormatter.weekDay(dateTime)
    return splitDay.join(' ')
  }

  // Try and parse the best price as a float
  const bestPriceData = parseFloat(oneDay?.bestPrice)
  // If it's a number, then use that value otherwise set it to null for processing later on
  const bestPrice = isNaN(bestPriceData) === true ? null : bestPriceData
  const bestPriceDisplay =
    chosenEvent == null ? 'adults_from' : chosenEvent.eventCalendarPriceText
  const bestPriceText =
    bestPriceDisplay == 'adults_from' ? 'Adults from $' : 'Tickets from $'

  const renderLoading = () => {
    return <LoadingIcon visible />
  }

  const renderFromEvent = () => {
    return (
      <>
        {loading && (
          <div className={'mobi-list-view-display-loader'}>
            {renderLoading()}
          </div>
        )}
        {!loading && (
          <>
            <div className={'mobi-select-expanded'}>
              {/* only show open alerts when the day is selected, otherwise keep alerts closed */}
              {showModal && (
                <div
                  role="alert"
                  className="yellow-bordered-content"
                >
                  <h4>
                    You have insufficient complimentary member tickets available
                    on this date to complete your order.
                  </h4>
                  <p>
                    If you would like to purchase additional tickets for this
                    date, you must purchase them at non-member pricing. Please
                    scroll down to continue.
                  </p>
                </div>
              )}

              <Alerts
                alerts={oneDay.alerts}
                fromMobiView={true}
              />

              <div className={'p-20'}>
                We expect {attendanceInfo(oneDay?.projectedAttendance)}{' '}
                attendance on this date. {hours}
              </div>
            </div>
            {!showModal && (
              <button
                className="button -big md:ml-16"
                data-testid="select-date"
                onClick={onSubmit}
              >
                {`Select ${fullDay(selectedDate)}`}
              </button>
            )}
          </>
        )}
      </>
    )
  }

  const renderNotFromEvent = () => {
    return (
      <>
        <div className={'mobi-select-expanded'}>
          {/* only show open alerts when the day is selected, otherwise keep alerts closed */}

          <Alerts
            alerts={oneDay.alerts}
            fromMobiView={true}
          />
          <PriceTable
            hours={hours}
            selectedDate={selectedDate}
            planningInfo={planningInfo}
            priceTableInfo={priceTableInfo}
            setPriceTableInfo={setPriceTableInfo}
            isMobiDisplayed={isMobiDisplayed}
          />
        </div>
        <button
          className="button -big md:ml-16"
          data-testid="select-date"
          onClick={onSubmit}
        >
          {`Select ${fullDay(selectedDate)}`}
        </button>
      </>
    )
  }

  if (unavailableDay) {
    return (
      <div
        data-tickets-available={false}
        tabIndex={0}
        key={dateTime}
        className={
          styles['mobi-unavailable'] + ' border ' + styles['mobi-rectangle']
        }
      >
        <div className={styles['mobi-non-alert']}>
          <SVG
            src={unavailableIcon}
            className={'stroke-current ' + styles['mobi-icon']}
            aria-hidden="true"
          />

          <div className={styles['mobi-text-div']}>
            <h4>{shortDays(dateTime)}</h4>
            <span className="small-paragraph">{unavailableDay && 'Unavailable'}</span>
          </div>
        </div>
      </div>
    )
  } else {
    let hasAlert = oneDay?.alerts.length !== 0
    let iconAvailable = attendanceInfo(oneDay?.projectedAttendance)

    return (
      <div
        data-tickets-available={bestPrice !== null ? true : false}
        tabIndex={0}
        key={dateTime}
        className={
          clickedElement?.ts === dateTime?.ts
            ? styles['mobi-rectangle'] + ' border ' + styles['mobi-selected']
            : 'border ' +
              styles['mobi-rectangle'] +
              ' ' +
              styles['mobi-' + iconAvailable]
        }
        onClick={e => clickedDay(e, dateTime)}
      >
        <div className={styles['mobi-top-row']}>
          <div className={styles['mobi-non-alert']}>
            {iconAvailable === 'medium' && (
              <SVG
                src={medium}
                className={'stroke-current ' + styles['mobi-icon']}
                aria-hidden="true"
              />
            )}
            {iconAvailable === 'high' && (
              <SVG
                src={high}
                className={'stroke-current ' + styles['mobi-icon']}
                aria-hidden="true"
              />
            )}
            {iconAvailable === 'low' && (
              <div style={{ width: 54, height: 27 }}></div>
            )}
            <span className="sr-only">
              {`expect ${attendanceInfo(
                oneDay?.projectedAttendance
              )} attendance`}
            </span>

            <div
              className={
                !iconAvailable
                  ? styles['mobi-no-icon-margin'] +
                    ' ' +
                    styles['mobi-text-div']
                  : styles['mobi-text-div']
              }
            >
              <h4>{shortDays(dateTime)}</h4>
              {bestPriceDisplay == 'hide' && <span></span>}
              {bestPriceDisplay != 'hide' && (
                <>
                  <span className="small-paragraph">
                    {bestPrice != null &&
                      `${bestPriceText}${
                        bestPrice % 1 !== 0 ? bestPrice.toFixed(2) : bestPrice
                      }`}
                  </span>
                  <span>
                    {!fromEvent &&
                      bestPrice === null &&
                      'General Admission unavailable'}
                  </span>
                </>
              )}
            </div>
          </div>
          <div className={'flex'}>
            <span
              className={styles['mobi-alert-icons']}
              style={hasAlert ? { display: 'flex' } : { display: 'none' }}
            >
              <SVG
                src={alertIcon}
                className={'stroke-current'}
                aria-hidden="true"
              />

              <span className="sr-only">alert icon</span>
            </span>
            <span
              className={styles['mobi-alert-icons']}
              style={{ display: 'flex' }}
            >
              <span style={{ display: 'flex' }}>
                <SVG
                  src={mobiCaretDown}
                  className={'stroke-current'}
                  aria-hidden="true"
                />
                <span className="sr-only">expand icon</span>
              </span>
            </span>
          </div>
        </div>

        {clickedElement?.ts === dateTime?.ts && (
          <>
            {fromEvent && renderFromEvent()}

            {!fromEvent && renderNotFromEvent()}
          </>
        )}
      </div>
    )
  }
}

export default ListViewDisplay
